import React, { useState, useEffect } from "react";
import style from './progressbar.module.scss';
import toPersianNumber from '../../../helpers/actions/toPersianNumber'
import { GetProgressBar } from '../../../actions/APIcalls'

const ProgressBar = (props) => {

    const [progressBarState, setProgressBarState] = useState({
        states: [
            { _id: 1, name: 'ثبت پنل', label: 'AddPanel', status: 'pending', link: '/channels' },
            { _id: 2, name: 'ویدئوهای آموزشی', label: 'Guide', status: 'pending', link: '/guide' },
            { _id: 3, name: 'تکمیل اطلاعات', label: 'AddRobot', status: 'pending', link: '/variants' },
            { _id: 4, name: 'مشاهده قیمت‌گذاری', label: 'Pricing', status: 'pending', link: '/pricing' },
            { _id: 5, name: 'دریافت شارژ هدیه', label: 'GetReward', status: 'pending', link: '/wallet' },
        ]
    })

    const stepIndicator = (step) => {
        let res = ''
        switch (step) {
            case 'completed':
                res = 'کامل شده'
                break;
            case 'inProgress':
                res = 'در حال انجام'
                break;
            case 'pending':
                res = 'در انتظار'
                break;
        }
        return res;
    }

    useEffect(async () => {
        await defineProgressBar()
    }, [])

    const defineProgressBar = async () => {
        let tmp = progressBarState
        tmp.states[0].status = 'inProgress'
        let res = await GetProgressBar()
        if (res && res.data && res.data.success) {
            let tmpLocal = res.data.progressData.progressBar
            tmp.states.map((el, index) => {
                if (tmpLocal[el.label]) {
                    tmp.states[index].status = 'completed'
                    if (typeof tmp.states[index + 1] != 'undefined') {
                        tmp.states[index + 1].status = 'inProgress'
                    }
                }
            })
            setProgressBarState({ ...tmp })
        }
    }

    return (
        <div className={style.wrapper}>
            {progressBarState.states.map((stateItem, stateIndex) => <a
                key={`stateIndex_${stateIndex}`}
                className={style.stateStepWrapper}
                href={(stateItem.status == 'inProgress' || stateItem.status == 'completed') ? stateItem.link : null}
            >
                <div className={style.stateStep}>
                    <div className={style[`${stateItem.status}_circle`]}>
                        {stateItem.status == 'inProgress' ? <div className={style.innerCircle}></div> : null}
                        {stateItem.status == 'completed' ? <div className={style.icon}></div> : null}
                    </div>
                    {stateIndex != 4 ? <div className={style[`${stateItem.status}_line`]}></div> : null}
                </div>
                <div className={style.stepTextWrapper}>
                    <p className={style.stepNumber}>مرحله {toPersianNumber(stateItem._id)}</p>
                    <p className={style.stepTitle}>{stateItem.name}</p>
                    <p className={style[`${stateItem.status}_stepStatus`]}>{stepIndicator(stateItem.status)}</p>
                </div>
            </a>)}
        </div>
    )
}
export default ProgressBar